exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.colora[data-v-178da92d] {\n  color: rgba(0, 0, 0, 0.87) rtant;\n}\n#gridComponent[data-v-178da92d] {\n  width: 100%;\n  height: 100% !important;\n  font-family: 'Asap', sans-serif;\n}\n#gridContainer[data-v-178da92d] {\n  -height: 62vh !important;\n  -background: green;\n}\n", ""]);

// exports
